interface ValidationRule {
  key: string
  required: boolean
  name?: string;
}

interface DataObject {
  [key: string]: any
}

/**
 * 验证数据对象中的字段是否满足要求
 * @param data 要验证的数据对象
 * @param rules 验证规则列表
 * @returns 返回验证结果和错误信息
 */
export const validateRequiredFields = (
  data: DataObject,
  rules: ValidationRule[]
): boolean => {

  let flag = false

  rules.forEach((rule) => {
    if (rule.required) {
      const value = data[rule.key]

      // 检查字段值是否为空（包括 undefined、null、空字符串等）
      if (
        value === undefined ||
        value === null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0)
      ) {
        flag = true
      }
    }
  })

  return flag
}


/**
 * 验证数组中的每个对象，但每个对象只返回第一个错误
 * @param dataArray 要验证的数据数组
 * @param rules 验证规则列表
 * @returns 返回验证结果和错误信息（每个对象最多一个错误）
 */

export const validateArrayDataFirstError = (
  dataArray: DataObject[], 
  rules: ValidationRule[]
): { 
  isValid: boolean; 
  error: any;
  invalidItems: number[];
} => {
  const errors: { index: number; field: string; message: string }[] = [];
  const invalidItems: number[] = [];
  let error = {}

  dataArray.forEach((data, index) => {
    // 对每个对象，只记录第一个错误
    let firstError: { field: string; message: string } | null = null;

    // 按规则顺序检查，找到第一个错误就停止
    for (const rule of rules) {
      if (rule.required) {
        const value = data[rule.key];
        const fieldName = rule.name || rule.key;
        
        // 检查字段值是否为空
        if (value === undefined || value === null || value === '') {
          firstError = {
            field: rule.key,
            // message: `第 ${index + 1} 行数据中，字段 ${fieldName} 是必填项，不能为空`
            message: `${fieldName} 是必填项，不能为空`
          };
          break; // 找到第一个错误就跳出循环
        }
      }
    }

    // 如果该对象有错误，记录第一个错误
    if (firstError) {
      error = firstError
      errors.push({
        index,
        field: firstError.field,
        message: firstError.message
      });
      invalidItems.push(index);
    }
  });

  return {
    isValid: errors.length === 0,
    error,
    invalidItems
  }
}